import { render, staticRenderFns } from "./couserView.vue?vue&type=template&id=3f96ff22&scoped=true"
import script from "./couserView.vue?vue&type=script&lang=js"
export * from "./couserView.vue?vue&type=script&lang=js"
import style0 from "./couserView.vue?vue&type=style&index=0&id=3f96ff22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96ff22",
  null
  
)

export default component.exports